import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import logo from "../../../resources/images/ats-blue.svg";
import { authActions } from "../../../actions/auth.actions";
import "./Spinner.scss";

const Progress = () => {
    const [progress, setProgress] = useState(0)
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loggingIn = useSelector((state) => state.authentication);
    const queryParams = new URLSearchParams(location.search)
    const queryData = queryParams.get('token')
    
    useEffect(() => {
        const allowUser = async(response) => {
        const data = JSON.parse(response)
        if(data){
            try {
                await dispatch(authActions.directLogin(data.token, navigate))
                    setTimeout(() => {
                        navigate("/openings");
                    }, 5000);
            } catch (error) {
                console.log(`Error:`,error)
            }
        }
    }
        if(queryData){
            allowUser(queryData);
        }
    }, [queryData]);

    useEffect(() => {
        const interval = setInterval(() => {
            if(progress <= 100){
                setProgress(progress + 10)
            } else {
                clearInterval(interval)
            } 
        }, 100);

        return () => {clearInterval()}
    }, [progress])
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
            <div style={{ marginBottom: '20px' }}>
                <img
                    src={logo}
                    alt="ATS Logo"
                    style={{ width: '500px', height: '500px' }}
                />
            </div>
            <div className="progress" style={{ width: '700px' }}>
                <div className="progress-bar progress-bar-animated custom-progress-bar" style={{ width: `${progress}%` }}></div>
            </div>
        </div>
    )
}

export default Progress;